// src/Pages/Photography/UntitledBodyProject.jsx
import * as React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { ThemeProvider, createTheme, Typography, Button, Modal } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

import pic1 from "./photography/untitledbodyproject/1_body.jpg";
import pic2 from "./photography/untitledbodyproject/2_body.jpg";
import pic3 from "./photography/untitledbodyproject/3_body.jpg";
import pic4 from "./photography/untitledbodyproject/4_body.jpg";
import pic5 from "./photography/untitledbodyproject/5_body.jpg";
import pic6 from "./photography/untitledbodyproject/6_body.jpg";
import pic7 from "./photography/untitledbodyproject/7_body.jpg";
import pic8 from "./photography/untitledbodyproject/8_body.jpg";
import pic9 from "./photography/untitledbodyproject/bodyexpo.png";

import Footer from "../Footer";

export default function UntitledBodyProject() {
  const base = createTheme();

  const theme = createTheme({
    typography: {
      fontFamily: "Helvetica",
      h1: { fontSize: "3rem", fontWeight: 200 },
      body1: {
        fontSize: "1.25rem",
        fontWeight: 200,
        lineHeight: 1.5,
        [base.breakpoints.down("sm")]: { fontSize: "1.25rem", fontWeight: 300 },
      },
    },
  });

  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const images = [pic1, pic2, pic3, pic4, pic5, pic6, pic7, pic8];

  const [open, setOpen] = React.useState(false);
  const [modalSrc, setModalSrc] = React.useState(null);

  const handleOpen = (src) => {
    setModalSrc(src);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  return (
    <ThemeProvider theme={theme}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        minHeight="100vh"
        marginTop="5vh"
        maxWidth="100vw"
        pb="10vh" // breathing space above footer
      >
        {/* Title */}
        <Box sx={{ mb: "5vh", width: "100%" }}>
          <Typography
            variant="h1"
            component={require("react-router-dom").Link}
            to="/ph"
            sx={{
              display: "block",          // ✅ ensures centering works on mobile
              textAlign: "center",
              color: "inherit",
              textDecoration: "none",
              cursor: "pointer",
              width: "100%",             // ✅ keeps the clickable area full-width
            }}
          >
            // untitled body project
          </Typography>
        </Box>

        {/* Intro */}
        <Box sx={{ width: "80vw", maxWidth: 1200, mb: "5vh", textAlign: "center" }}>
          <Typography variant="body1">
            project realized during a workshop with{" "}
            <a href="https://sabinabosch.com" target="_blank" rel="noreferrer">
              Sabina Bösch</a><br /><br />
              // exposed at <a href="https://korso.ch" target="_blank" rel="noreferrer">Korso</a> from 29.05 to 27.06.2025
          </Typography>
        </Box>

        {/* Grid of images */}
        <Grid
          container
          spacing={2}
          justifyContent="center"
          alignItems="center"
          sx={{ width: "80vw", maxWidth: 1200 }}
        >
          {images.map((src, i) => (
            <Grid key={i} item xs={12} sm={6} md={3} sx={{ display: "flex", justifyContent: "center" }}>
              {isDesktop ? (
                <Button
                  onClick={() => handleOpen(src)}
                  sx={{ p: 0, minWidth: 0, lineHeight: 0, cursor: "zoom-in" }}
                >
                  <img src={src} alt={`Untitled Body Project ${i + 1}`} style={{ width: "100%", height: "auto" }} />
                </Button>
              ) : (
                <img src={src} alt={`Untitled Body Project ${i + 1}`} style={{ width: "100%", height: "auto" }} />
              )}
            </Grid>
          ))}
        </Grid>

        {/* Credit */}
        <Box
          sx={{
            width: "80vw",
            maxWidth: 1200,
            textAlign: "center",
            mt: { xs: "6vh", sm: "4vh" }, // more space on mobile
            mb: { xs: "6vh", sm: "4vh" },
          }}
        >
          <Typography variant="body1">ECAL Leonid Pesenti © 2025</Typography>
        </Box>

        {/* Centered poster */}
        <Box
          sx={{
            width: "80vw",
            maxWidth: 1200,
            display: "flex",
            justifyContent: "center",
            mb: "4vw", // leave as is
          }}
        >
          <img src={pic9} alt="Body Expo poster" style={{ width: "80%", maxWidth: 400, height: "auto" }} />
        </Box>
      </Box>

      {/* Modal (desktop only) */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 0,
            outline: "none",
            maxWidth: "90vw",
            maxHeight: "80vh",
            display: "flex",
          }}
        >
          {modalSrc && (
            <img
              src={modalSrc}
              alt="Preview"
              style={{ maxWidth: "90vw", maxHeight: "80vh", width: "auto", height: "auto" }}
            />
          )}
        </Box>
      </Modal>

      <Footer fixed />
    </ThemeProvider>
  );
}
